import { createStyles, makeStyles } from '@material-ui/core'
import { GridCellParams, GridColDef, DataGrid, GridSortDirection, GridValueFormatterParams } from '@material-ui/data-grid'
import _ from 'lodash'
import React, { useMemo } from 'react'
import { useHistory } from 'react-router'
import { DataGridBoolean } from '../../../Components/DataGrid/DataGridBoolean'
import { ConsigneeSchema, ConsigneeType } from '../../../Schema/ConsigneeSchema'
import { formatLocalDateTime } from '../../../Utils/DateFunctions'
import { ConsigneeTag } from './ConsigneeTag'
import { ConsigneeTypeChip } from './ConsigneeTypeChip'

const columns: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Name',
    width: 300,
    renderCell: (params: GridValueFormatterParams) => {
      return <ConsigneeTag consigneeId={params.getValue(params.id, 'id')?.toString()} />
    },
  },
  {
    field: 'type',
    headerName: 'Type',
    width: 300,
    renderCell: (params: GridValueFormatterParams) => {
      return <ConsigneeTypeChip type={params.getValue(params.id, 'type') as ConsigneeType} />
    },
  },
  {
    field: 'address',
    headerName: 'Address',
    width: 200,
  },
  {
    field: 'city',
    headerName: 'City',
    width: 200,
  },
  {
    field: 'state',
    headerName: 'State',
    width: 200,
  },
  {
    field: 'postalCode',
    headerName: 'Postal Code',
    width: 200,
  },
  {
    field: 'country',
    headerName: 'Country',
    width: 200,
  },
  {
    field: 'courierEnabled',
    headerName: 'Courier?',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridValueFormatterParams) => {
      return <DataGridBoolean params={params} />
    },
  },
  {
    field: 'isEnabled',
    headerName: 'Enabled?',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridValueFormatterParams) => {
      return <DataGridBoolean params={params} />
    },
  },
  {
    field: 'updated',
    headerName: 'Updated',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'updated') as Date)
    },
  },
  {
    field: 'created',
    headerName: 'Created',
    width: 180,
    type: 'dateTime',
    valueFormatter: (params: GridValueFormatterParams) => {
      return formatLocalDateTime(params.getValue(params.id, 'created') as Date)
    },
  },
]

interface ConsigneesDataGridProps {
  entities: ConsigneeSchema[] | Record<string, ConsigneeSchema>
}

export const ConsigneesDataGrid: React.FC<ConsigneesDataGridProps> = ({
  entities,
}) => {
  const history = useHistory()
  const styles = useStyles()

  const [sortModel, setSortModel] = React.useState([
    {
      field: 'name',
      sort: 'asc' as GridSortDirection,
    },
  ])

  const rows: ConsigneeSchema[] = useMemo(() => {
    return _.map(entities)
  }, [entities])

  const handleOnCellClick = (params: GridCellParams) => {
    /* if (_.includes(['status', 'assigneeId'], cellParams.field)) {
      return
    } */
    history.push(`/consignee-management/consignees/${params.getValue(params.id, 'id')}`)
  }

  return (
    <DataGrid
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
      className={styles.grid}
      columns={columns}
      rows={rows}
      showColumnRightBorder
      onCellClick={handleOnCellClick}
    />
  )
}

const useStyles = makeStyles(theme =>
  createStyles({
    grid: {
      fontSize: 14,
    },
  }),
)
